<template>
  <v-bottom-navigation fixed light horizontal class="d-flex justify-space-between align-center">
    <div class="d-flex d-column" style="height:100%;">
      <v-btn to="/users/dashboard" color="amber accent-1">
        <span>Dashboard</span>
        <v-icon>mdi-blur-radial</v-icon>
      </v-btn>

      <v-btn :to="`/users/project/${$route.params.id}`" color="amber accent-2">
        <span>Project</span>
        <v-icon>mdi-blur-radial</v-icon>
      </v-btn>
      <v-btn v-if="list" :to="`/users/project/${$route.params.id}/${list}`" color="amber accent-3">
        <span>List</span>
        <v-icon>mdi-blur-radial</v-icon>
      </v-btn>
    </div>

    <slot> </slot>

    <v-switch v-if="gridToggle" v-model="gridView" color="amber" label="Grid / Carousel" class=""></v-switch>

    <v-col cols="2" v-if="gridView">
      <v-slider v-model="range" v-on:input="updateValue" class="align-center" label="Zoom" color="amber" max="10"
        min="2" hide-details thumb-color="amber" track-color="amber accent-1"></v-slider>
    </v-col>

    <div class="d-flex d-column" style="height:100%;">
      <v-btn @click="$emit('prev')" color="amber accent-2" class="" v-if="prev">
        <span class="subtitle-2">BACK</span>
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-btn @click="$emit('next')" color="amber" v-if="next">
        <span class="subtitle-2">NEXT</span>
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
      <v-btn @click="$emit('save', true)" color="amber" v-if="save">
        <span class="subtitle-2">{{ saveLabel ? saveLabel : 'SAVE' }}</span>
        <v-icon>mdi-check</v-icon>
      </v-btn>
    </div>
  </v-bottom-navigation>
</template>

<script>
// @ is an alias to /src
export default {
  name: "BottomNavigation",
  data() {
    return {
      range: this.value,
    };
  },
  props: {
    value: Number,
    save: Boolean,
    saveLabel: String,
    next: Boolean,
    prev: Boolean,
    gridView: Boolean,
    gridToggle: Boolean,
    list: {
      type: String,
      default: null,
    },
  },
  methods: {
    updateValue() {
      this.$emit("input", this.range);
    },
  },
};
</script>
